import { makeActionCreator } from '../../util/make_action_creator'

export const SET_CURRENT = 'SET_CURRENT'
export const setCurrent = makeActionCreator(
  SET_CURRENT,
  'currentObj',
  'replaceState',
)

export const SET_CURRENT_TITLE = 'SET_CURRENT_TITLE'
export const setCurrentTitle = makeActionCreator(SET_CURRENT_TITLE, 'title')
